<template>
  <div class="dispatch-container">
    <div class="left">
      <!-- 人员统计 -->
      <div class="statistics">
        <cus-border title="人员统计" ref="blya1">
          <left-static :item="people"></left-static>
        </cus-border>
      </div>
      <!-- 车辆统计 -->
      <div class="statistics margin">
        <cus-border title="车辆统计" ref="blya2">
          <left-static :item="car"></left-static>
        </cus-border>
      </div>
      <!-- 船只统计 -->
      <div class="statistics">
        <cus-border title="船只统计" ref="blya3">
          <left-static :item="ship"></left-static>
        </cus-border>
      </div>
    </div>
    <div class="center">
      占位
      <!-- <div class="center-map">
        <drawn-map></drawn-map>
      </div> -->
    </div>
    <div class="right">
      <cus-border title="设备列表" ref="blya4">
        <equipment></equipment>
      </cus-border>
    </div>
  </div>
</template>
<script>
  // 导入地图
  // import drawnMap from '@/components/drawn-map/drawn-map'
  // 导入边框组件
  import cusBorder from '@/components/cus-border/cus-border'
  // 导入左边统计图
  import leftStatic from './components/left-static'
  //   导入设备列表
  import equipment from './components/equipment'
  export default {
    components: {
      // drawnMap,
      cusBorder,
      leftStatic,
      equipment,
    },
    data() {
      return {
        people: {
          total: 1528,
          number: 1208,
          icon: 'icon1',
          name: '人员总数（人）',
          color: '#FF943D',
        },
        car: {
          total: 64546,
          number: 64330,
          icon: 'icon2',
          name: '车辆总数（辆）',
          color: '#02F6FF',
        },
        ship: {
          total: 200,
          number: 194,
          icon: 'icon3',
          name: '船只总数（艘）',
          color: '#7784FF',
        },
        equipmentList: {},
      }
    },
    mounted() {
      this.init()
    },
    beforeDestroy() {
      this.$animejs.remove(['.statistics', '.svg-container', '.right'])
    },
    methods: {
      init() {
        let anime = this.$animejs
        // form 动效card
        anime({
          targets: '.statistics',
          translateX: [-600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(300),
        })
        anime({
          targets: '.right',
          translateX: [600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: 300,
        })
        anime({
          targets: '.svg-container',
          boxShadow: [
            {
              value: '0 0 6px 6px rgba(255,255,255,.2)',
              easing: 'easeOutSine',
              duration: 1000,
            },
            {
              value: '0 0 0 0 rgba(255,255,255,.2)',
              easing: 'easeInOutQuad',
              duration: 1500,
            },
          ],
          delay: anime.stagger(100, { grid: [14, 5], from: 'center' }),
        })
        window.onresize = () => {
          this.$refs.blya1.init()
          this.$refs.blya2.init()
          this.$refs.blya3.init()
          this.$refs.blya4.init()
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .dispatch-container {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    position: relative;
    .center-map {
      position: fixed;
      height: 100vh;
      width: 100vw;
      left: 0;
      top: 0;
    }
    .left {
      position: relative;
      z-index: 2;
      width: 23.59375vw;
      .statistics {
        height: 27.5vh;
      }
      .margin {
        margin: 1.5vh 0;
      }
    }
    .center {
      flex-grow: 1;
      color: transparent;
    }
    .right {
      position: relative;
      z-index: 2;
      width: 23.59375vw;
      height: 85.4154vh;
    }
  }
</style>
